export const arrayPrecioRango: any[] = [
  { name: '0€', value: '0' },
  { name: '50.000€', value: '50000' },
  { name: '100.000€', value: '100000' },
  { name: '150.000€', value: '150000' },
  { name: '200.000€', value: '200000' },
  { name: '250.000€', value: '250000' },
  { name: '300.000€', value: '300000' },
  { name: '350.000€', value: '350000' },
  { name: '400.000€', value: '400000' },
  { name: '450.000€', value: '450000' },
  { name: '>500.000€', value: '500000' },
];
export const arrayPrecioDe: any[] = [
  { name: '0€', value: '0' },
  { name: '50.000€', value: '50000' },
  { name: '100.000€', value: '100000' },
  { name: '150.000€', value: '150000' },
  { name: '200.000€', value: '200000' },
  { name: '250.000€', value: '250000' },
  { name: '300.000€', value: '300000' },
  { name: '350.000€', value: '350000' },
  { name: '400.000€', value: '400000' },
  { name: '450.000€', value: '450000' },
  { name: '>500.000€', value: '500000' },
];
export const arrayPrecioa: any[] = [
  { name: '50.000€', value: '50000' },
  { name: '100.000€', value: '100000' },
  { name: '150.000€', value: '150000' },
  { name: '200.000€', value: '200000' },
  { name: '250.000€', value: '250000' },
  { name: '300.000€', value: '300000' },
  { name: '350.000€', value: '350000' },
  { name: '400.000€', value: '400000' },
  { name: '450.000€', value: '450000' },
  { name: '500.000€', value: '500000' },
  { name: '∞', value: '999999999' },
];

export const arrayRentabilidad: any[] = [
  { name: '0%', value: '0' },
  { name: '1%', value: '1' },
  { name: '2%', value: '2' },
  { name: '3%', value: '3' },
  { name: '4%', value: '4' },
  { name: '5%', value: '5' },
  { name: '6%', value: '6' },
  { name: '7%', value: '7' },
  { name: '8%', value: '8' },
  { name: '9%', value: '9' },
  { name: '10%', value: '10' },
];

export const superficieOptions: any[] = [
  { value: 30, labelEn: 'To 30 m2.', label: 'Hasta 30 m2.' },
  { value: 100, labelEn: 'To 100 m2.', label: 'Hasta 100 m2.' },
  { value: 200, labelEn: 'To 200 m2.', label: 'Hasta 200 m2.' },
  { value: 300, labelEn: 'To 300 m2.', label: 'Hasta 300 m2.' },
  { value: 400, labelEn: 'To 400 m2.', label: 'Hasta 400 m2.' },
  { value: 500, labelEn: 'To 500 m2.', label: 'Hasta 500 m2.' },
  { value: 600, labelEn: 'To 600 m2.', label: 'Hasta 600 m2.' },
  { value: 700, labelEn: 'To 700 m2.', label: 'Hasta 700 m2.' },
  { value: 800, labelEn: 'To 800 m2.', label: 'Hasta 800 m2.' },
];

export const importeRentaDe: any[] = [
  { name: '0€', value: '0' },
  { name: '100€', value: '100' },
  { name: '200€', value: '200' },
  { name: '300€', value: '300' },
  { name: '400€', value: '400' },
  { name: '500€', value: '500' },
  { name: '700€', value: '700' },
  { name: '1000€', value: '1000' },
  { name: '1200€', value: '1200' },
  { name: '1400€', value: '1400' },
  { name: '1600€', value: '1600' },
  { name: '1800€', value: '1800' },
  { name: '2000€', value: '2000' },
  { name: '2200€', value: '2200' },
  { name: '2300€', value: '2300' },
];
export const importeRentaHasta: any[] = [
  { name: '100€', value: '100' },
  { name: '200€', value: '200' },
  { name: '300€', value: '300' },
  { name: '400€', value: '400' },
  { name: '500€', value: '500' },
  { name: '700€', value: '700' },
  { name: '1000€', value: '1000' },
  { name: '1200€', value: '1200' },
  { name: '1400€', value: '1400' },
  { name: '1600€', value: '1600' },
  { name: '1800€', value: '1800' },
  { name: '2000€', value: '2000' },
  { name: '2200€', value: '2200' },
  { name: '2300€', value: '2300' },
  { name: '2500€', value: '2500' },
];
